export default __webpack_public_path__ + "static/koi-laptop1-f378b197ee06d8be4e582185038f1143.png";